import { call, put, takeLatest } from 'redux-saga/effects';
import { getQesParticipation } from '../../services/API';
import { actionTypes, getParticipationFailure, getParticipationSuccess } from './actions';

function* getData(action) {
  const { isOk, data, error } = yield call(getQesParticipation, action.payload);
  yield put(isOk ? getParticipationSuccess(data) : getParticipationFailure(error));
}

export default function* participationInQesOrganizationsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
